<template>

  <div>

    <div v-if="permissions.includes('manage_candidates')">
      <div
        v-if="!selectedJob"
        class="alert alert-warning">
        {{ $t('To request a questionnaire, select a job') }}
      </div>
      <div v-if="resourceAvailability.features.includes('questionnaires')">
        <div
          v-if="!candidate.email"
          class="alert alert-warning">
          O candidato não possui e-mail
        </div>
        <div
          v-if="selectedJob && candidate.email"
          class="card">
          <div class="card-body">
            <CandidateQuestionnaireInvite  />
          </div>
        </div>
        <CandidateQuestionnaireInviteList />
      </div>
      <div v-if="!resourceAvailability.features.includes('questionnaires')">
        <Unavailable
          title="Questionários e testes" />
      </div>
    </div>

    <CandidateFeed :activityType="'questionnaire'" />

  </div>

</template>

<script>
import CandidateQuestionnaireInvite from './CandidateQuestionnaireInvite'
import CandidateQuestionnaireInviteList from './CandidateQuestionnaireInviteList'
import CandidateFeed from '../Feed/CandidateFeed'
import Unavailable from '../../Unavailable/Unavailable'

export default {
  name: 'CandidateQuestionnaire',
  components: {
    CandidateQuestionnaireInvite,
    CandidateQuestionnaireInviteList,
    CandidateFeed,
    Unavailable
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    },
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Questionnaire/CandidateQuestionnaire.vue